{
  "logoUrl": "https://www.djurensratt.se",
  "ctaButton": {
    "title": "Stöd oss",
    "url": "https://www.djurensratt.se/stod-oss"
  }
}
